/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import { bool, string } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import NavigationRoutes from 'components/layouts/Navigation/NavigationRoutes';
import PageLoadingContainer from 'components/layouts/Navigation/PageLoadingContainer';
import { getLocationRequestStateKey } from 'state/requests/RequestStatusSelectors';
import { requestStateConfig } from 'components/layouts/Navigation/RequestStateConfig';
import { routerConfig } from 'components/layouts/Navigation/NavigationConfig';

const BenefitsNavigationContainer = ({
  requestStatesKey,
  hasError,
  containerClass,
  children
}) => {
  return (
    <Fragment>
      {children}
      <div className={containerClass}>
        <PageLoadingContainer
          hasError={hasError}
          name="Benefits"
          requestStates={requestStateConfig[requestStatesKey]}
        >
          <NavigationRoutes config={routerConfig} />
        </PageLoadingContainer>
      </div>
    </Fragment>
  );
};

BenefitsNavigationContainer.propTypes = {
  hasError: bool.isRequired,
  requestStatesKey: string.isRequired
};

const mapStateToProps = (state) => ({
  requestStatesKey: getLocationRequestStateKey(state)
});

export default connect(mapStateToProps)(BenefitsNavigationContainer);
